module.exports = __webpack_public_path__ + "static/media/Expert.90a3be7e.svg";